<template>
<div>
<div class="sub_visual_wrap">
    <div class="sub_visual_box container">
        <div class="page_nav">
            <ul>
                <li><router-link to="/main" @click.native="$store.commit('setActive','')">{{$t('common.home')}}</router-link></li>
                <li><a href="#">{{$t('management.symbollibrary')}}</a></li>
            </ul>
        </div>	
        <h2>{{$t('management.symbollibrary')}}</h2>
    </div>
</div> 
<section class="container">
<div class="sub_contents_wrap">
<p class="mgb_10">{{$t('management.symbolInfo')}}</p>
<div class="symbol_row">
    <div class="symbole_box">
        <table class="tbl_public">
            <colgroup>
                <col style="width:10%">
                <col style="width:15%">
                <col style="width:30%">
                <col style="width:45%">
            </colgroup>
            <thead>
            <tr>
                <th></th>
                <th>{{$t('management.symbol')}}</th>
                <th>{{$t('management.type')}}</th>
                <th>{{$t('management.meaning')}}</th>
            </tr>
            </thead>
            <tbody> 
                <tr v-for="(sym,index) in symbolList1" :key="index">
                    <td>{{index+1}}</td>
                    <td>
                        <span>
                            <img :src="'/symbollibrary/img/'+sym.imgFileNo">
                        </span>
                    </td>
                    <td>{{sym.type}}</td>
                    <td class="text-left">{{sym.meaning}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="symbole_box symbol_r_type">
        <table class="tbl_public">
            <colgroup>
                <col style="width:10%">
                <col style="width:15%">
                <col style="width:30%">
                <col style="width:45%">
            </colgroup>
            <thead>
            <tr>
                <th></th>
                <th>{{$t('management.symbol')}}</th>
                <th>{{$t('management.type')}}</th>
                <th>{{$t('management.meaning')}}</th>
            </tr>
            </thead>
            <tbody>
               <tr v-for="(sym,index) in symbolList2" :key="index">
                    <td>{{secondListIndex+index}}</td>
                    <td>
                        <span>
                            <img :src="'/symbollibrary/img/'+sym.imgFileNo">
                        </span>
                    </td>
                    <td>{{sym.type}}</td>
                    <td class="text-left">{{sym.meaning}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    </div>
</div>
</section>   
</div>
</template>

<script>
import { getSymbolLibraryList } from '@/api/symbollibrary';
export default {
 data() {
        return { 
            symbolList : [],
            symbolList1: [],
            symbolList2: [],
            secondListIndex : 0,
        }  
    },
    created(){
        this.fetchData();
    },   
    methods : {
        async fetchData(){  
            try {
                const {data} = await getSymbolLibraryList();
                this.symbolList = data.symbolList; 
                var lenghtHalf = Math.ceil(this.symbolList.length/2);
                this.secondListIndex = lenghtHalf+1;
                this.symbolList1 = this.symbolList.slice(0,lenghtHalf);
                this.symbolList2 = this.symbolList.slice(lenghtHalf,this.symbolList.length);
            } catch (error) {
                console.log(error);
            }
        },	
    }    
}
</script>

<style>

</style>